import Api from "./Api";

export class Kpi extends Api {
    /**
     * @param {KpiProgress} progress 
     */
    saveProgress(progress) {
        return this._post("", progress);
    }
}

export default Kpi;
